import React, { useState, useEffect } from 'react';
import API from '../../../services/API';
import CustomStore from 'devextreme/data/custom_store';

import {
  Column,
  DataGrid,
  Paging,
  Editing,
  Lookup,
} from 'devextreme-react/data-grid';
import useStyles from '../../styles/styles';
import usePermissions from '../../../hooks/usePermissions';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../../global';
import { Template } from 'devextreme-react/core/template';

const valueCategories = new CustomStore({
  key: 'ValueCategoryId',
  load: async () => {
    const { data } = await API.sendRequest(`ValueCategory`, 'get');
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`ValueCategory`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`ValueCategory`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`ValueCategory/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const ValueCategory = () => {
  const classes = useStyles();
  const [areas, setAreas] = useState([]);
  useEffect(() => {
    let isSubscribed = true;

    API.sendRequest('Area', 'GET', false).then((res) => {
      if (res.status === 200 && isSubscribed) {
        setAreas(res.data);
      }
    });

    return () => {
      isSubscribed = false;
    };
  }, []);

  /** *******************************
   * Access Control
   ******************************** */
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <div />;
  }
  if (ACL.NoAccess) {
    return (
      <LoadPermissions>You don't have access to this page</LoadPermissions>
    );
  }
  ACL.BreadCrumb = 'Performance / Values Categories';
  /** ****************************** */

  return (
    <div className={classes.divSmallGridContainer}>
      <DataGrid
        id="gridContainer"
        dataSource={valueCategories}
        eyExpr="ValueCategoryId"
        allowColumnReordering
        showBorders
        rowAlternationEnabled
        focusedRowEnabled
        showRowLines
        onRowUpdating={onRowUpdating}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />
        <Editing
          useIcons
          mode="form"
          allowAdding={ACL.AddNew}
          allowUpdating={ACL.Update}
          allowDeleting={ACL.Delete}
        />

        <Column dataField="ValueCategoryDesc" caption="Description" />
        <Column dataField="AreaId" caption="Area" width={125}>
          <Lookup
            dataSource={areas}
            displayExpr="AreaDesc"
            valueExpr="AreaId"
          />
        </Column>
        <Column dataField="ValueCategoryOrder" caption="Order" />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default ValueCategory;
